export default __webpack_public_path__ + "static/simple-line-36325995971917e6af55ddb440eddb1f.png";